module.exports = __webpack_public_path__ + "static/media/ic_pdf_file.31c88841.svg";